export function roundToTwo(num) {
	return Math.round(num * 100) / 100;
}

export function sumNumericBy(items, source) {
	return items.reduce((total, item) => {
		const value = Number(item[source]);
		return Number.isNaN(value) ? total : total + value;
	}, 0);
}
